<div class="fill-parent">
    <div class="report-head">
      <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="navigateBack()"><img src="/assets/images/back.svg" />Chart Dashboard</button></div>
      <div class="report-title detail-page-title margin-l-l">
        Utilization Across Devices
      </div>
      <div class="report-date">
        <mat-form-field (click)="picker.open()"  class="report-picker" appearance="outline">
          <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" placeholder="Start Date">
          <mat-datepicker-toggle class="picker-icon" matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker (closed)="onSelectDate()"  #picker></mat-datepicker>
        </mat-form-field>
  
        <mat-form-field (click)="picker2.open()"  class="report-picker" appearance="outline">
          <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" placeholder="Start Date">
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker (closed)="onSelectDate()"  #picker2></mat-datepicker>
        </mat-form-field>
        <!--<mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-input  [rangePicker]="picker">
          <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
          <input matEndDate [(ngModel)]="endDate" placeholder="End date">
        </mat-date-input>
        <mat-date-range-picker (closed)="onSelectDate()" #picker></mat-date-range-picker>!-->
      </div>
    </div>
    <div class="flex-grow-1 display-flex flex-col">
      <table mat-table matSort (matSortChange)="schoolsSortChange($event)" [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="chart">
          <th mat-header-cell *matHeaderCellDef>  Device Utilization(%) </th>
          <td mat-cell *matCellDef="let element">       
            <div>
              <ngx-charts-pie-chart 
              [view] = "[75, 75]"
              [customColors]="barChartcustomColors"
              [results]="element.data"
              [labels]=false
              [trimLabels]= false>
              </ngx-charts-pie-chart>
            </div>


        </ng-container>
        <ng-container matColumnDef="deviceName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by deviceName"> Device Name </th>
          <td mat-cell *matCellDef="let element"> {{element.deviceName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="deviceType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by deviceType"> Device Type </th>
          <td mat-cell *matCellDef="let element"> {{element.deviceType}} </td>
        </ng-container>

        <ng-container matColumnDef="regDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by regDate"> Registration Date </th>
            <td mat-cell *matCellDef="let element"> {{element.createdAt|date:'dd/MM/yyyy'}} </td>
          </ng-container>
        
        <ng-container matColumnDef="lastSynched">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by lastSynched"> Latest synched </th>
          <td mat-cell *matCellDef="let element">  {{element.latestSyncDate|date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <ng-container matColumnDef="scanDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by scanDate"> Last Scan </th>
            <td mat-cell *matCellDef="let element"> {{element.lastScanDate|date:'dd/MM/yyyy'}} </td>
          </ng-container>
    
  
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="navigateTo(row)"></tr>
        
      </table> 
      <mat-paginator [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>    
      </div>
        
  </div>
  